import { postRequestWithRetry } from '../utils/asyncRequest';

const API_ENDPOINT = '/ads-navigator';

export interface SearchResponse {
  recommendedPages?: PageResult[];
}

export interface PageResult {
  page: string;
  title: string;
}

export interface SearchRequest {
  question: string;
  mode?: string;
  locale?: string;
}

const searchAdsNavigator = async (
  request: SearchRequest,
  signal?: AbortSignal,
): Promise<SearchResponse> => {
  const config = {
    url: API_ENDPOINT,
    data: request,
    headers: {
      'Content-Type': 'application/json',
    },
    ...(signal && { signal }),
  };

  const response = await postRequestWithRetry(config);
  return response.data;
};

export default searchAdsNavigator;
